/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchSummary
 */
export interface BatchSummary {
    /**
     * 
     * @type {string}
     * @memberof BatchSummary
     */
    batchId: string | null;
}

/**
 * Check if a given object implements the BatchSummary interface.
 */
export function instanceOfBatchSummary(value: object): value is BatchSummary {
    if (!('batchId' in value) || value['batchId'] === undefined) return false;
    return true;
}

export function BatchSummaryFromJSON(json: any): BatchSummary {
    return BatchSummaryFromJSONTyped(json, false);
}

export function BatchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'batchId': json['batchId'],
    };
}

  export function BatchSummaryToJSON(json: any): BatchSummary {
      return BatchSummaryToJSONTyped(json, false);
  }

  export function BatchSummaryToJSONTyped(value?: BatchSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batchId': value['batchId'],
    };
}

